import React from "react";
import { Link } from "react-router-dom";
import { songs } from "../../../../database/song";
import Layout from "../../../Layout";
import MusicPlayer from "../../../MusicPlayer";
import Lib_Card from "../Lib_Card";

export default function Lib_Albums() {
  return (
    <>
      <Layout isLibrary={true} />
      <div className="pl-64 pt-20 w-screen pb-32">
        <h4 className="text-white text-xl font-semibold">Albums</h4>
        <div className="flex flex-wrap ">
          {songs.map((data) => {
            return data.type == "song" ? (
              <Link to={`/album/${data._id}`} key={data._id}>
                <Lib_Card data={data} type="song" key={data._id} />
              </Link>
            ) : null;
          })}
        </div>
      </div>
      {/* <MusicPlayer /> */}
    </>
  );
}
